import { lazyModulePage } from '@/soluqr/tiers/lazyModulePage';

export const menuRouteElements = [
  {
    segment: 'products',
    element: lazyModulePage('menu', () => import('@/soluqr/modules/menu/screens/ProductsPage')),
  },
  {
    segment: 'promos',
    element: lazyModulePage('menu', () => import('@/soluqr/modules/menu/screens/PromosPage')),
  },
];
